import { BackIcon, HomeIcon, ShareIcon } from "../ui/atoms"

export const HEADER_ICON_MAP = {
  back: BackIcon,
  home: HomeIcon,
  share: ShareIcon,
} as const

